"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M22 3h-3V1h-2v2H7V1H5v2H2v20h20zm-2 18H4V8h16z"
}), 'CalendarTodaySharp');